const tags = [{ ref: 1, name: 'red' }, { ref: 2, name: 'blue' }, { ref: 3, name: 'green' }];

export function getTagById(id) {
  if (!id) {
    return { ref: 0, name: '' };
  }
  return tags.find(tag => tag.ref === id);
}

export function getTag(tag) {
  if (tag && tag.ref) {
    return getTagById(tag.ref);
  }
  return getTagById(0);
}

export default tags;



// WEBPACK FOOTER //
// ./src/config/tags.js